import React, { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  CardContent,
  Grid,
  Divider,
  styled,
  Switch,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import { useFormik } from "formik";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { NodCommercialRoute } from "../../nod-commercial.routes";
import { columns } from "./components/columns";
import * as Yup from "yup";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  selectLoader,
  selectPaymentTypes,
  selectWeightScanTypes,
  selectPaymentTypeDetail,
  addPaymentAction,
  removeGridItem,
  removeAllPayments,
} from "src/app-redux/commercial/commercialSlice";
import { useAppSelector } from "src/app-redux/hooks";
import {
  getPaymentTypesDropdownAction,
  getPaymentTypeDetailsAction,
  postTerminalChargesWholeRecordAction,
} from "src/app-redux/commercial/actions/commercialActions";
import { useStyles } from "./components/style";
import { numberFormatting } from "src/common/utils/helpers";
import Checkbox from "@mui/material/Checkbox";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonLoader from "src/components/Loader/CommonLoader";
import { TerminalDetails } from "./components/TerminalDetails";
import {
  selectAllPartyNameRowsList,
  selectAllTaxTypeRowsList,
  selectAllAgent,
} from "src/app-redux/configuration/configurationSlice";
import {
  getAllPartName,
  getAllTaxTypes,
  getAllAgents,
} from "src/app-redux/configuration/actions/configurationActions";

interface Props {}

export function TerminalCharges({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const allTaxTypeRows = useAppSelector(selectAllTaxTypeRowsList);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = NodCommercialRoute.title;
  const pageHeading = NodCommercialRoute.subRoutes
    ? NodCommercialRoute.subRoutes[0].title
    : "Page Title";
  const [loader2, setLoader2] = useState<any>(false);
  const [isOtherPayment, setIsOtherPayment] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [isOpenDublicateDailog, setIsOpenDublicateDailog] = useState<boolean>(false);
  const [isVehicleAdd, setVehicleAdd] = useState(false);
  const [pendingContainerList, setPendingContainerList] = React.useState<any>([]);
  const [virContainerList, setVirContainerList] = React.useState<any>([]);
  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [deleteGridItemId, setDeleteGridItemId] = useState<any>("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [filterGridRecord, setFilterGridRecord] = useState<any>([]);
  const [apiSubmitRecordData, setApiSubmitRecordData] = useState<any>([]);
  const loading = useAppSelector(selectLoader);
  const paymentTypes: any[] = useAppSelector(selectPaymentTypes);
  const paymentTypeDetail = useAppSelector(selectPaymentTypeDetail);
  const weightScanTypesRecord = useAppSelector(selectWeightScanTypes);
  const [paymentTypesList, setPaymentTypesList] = useState<any>([]);
  const [containerDetails, setContainerDetails] = useState<any>({});
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [dialogContent, setDialogContent] = useState<any>();
  const [atCommercialStation, setatCommercialStation] = useState<boolean>(false);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  const [numberOfCbm, setNumberOfCbm] = useState(0);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = React.useState<number>(0);
  const [filteredNominations, setFilteredNominations] = useState<any[]>([]);
  const [nominationDetails, setnominationDetails] = useState<any>({});
  const terminalType = Number(localStorage.getItem("terminalType"));
  const [, setVehicleContanerNumbers] = React.useState<any>([]);
  const [, setStayDays] = useState(0);
  const [storageDays, setStorageDays] = useState(0);
  const [, setStorageSlabs] = useState<any[]>([]);
  const [isExportMode, setIsExportMode] = useState<boolean>(false);
  const [, setGdList] = React.useState<any>([]);
  const [, setGdVehiclesList] = React.useState<any>([]);
  const [gdContainerList, setGdContainerList] = React.useState<any>([]);
  // const [scanning, setScanning] = useState<any>();
  // const [weight, setWeight] = useState<any>();
  // const [cargoType, setcargoType] = useState<string>("");
  // const [consignmentType, setconsignmentType] = useState<string>("");
  // const [vehicleType, setvehicleType] = useState<string>("");
  // const [entryDateTime, setentryDateTime] = useState<string>("");
  const [vehicleStatusData, setVehicleStatusData] = useState<any>({});
  const [discountApplied, setDiscountApplied] = useState<boolean>(false);
  const [discountPercentage, setDiscountPercentage] = useState<number>(0);
  const [originalCharges, setOriginalCharges] = useState<number>(0);

  const allPartyNameRows = useAppSelector(selectAllPartyNameRowsList);

  const resolvePartyIdToNumber = (raw: any): number | null => {
    if (raw === "" || raw == null) return null;
    const num = Number(raw);
    if (!Number.isNaN(num) && num > 0) return num;
    const byName = allPartyNameRows.find(
      (p: any) => (p.name && String(p.name).trim()) === String(raw).trim()
    );
    const id = (byName as any)?.id;
    return id != null ? id : null;
  };

  const getNominationsByParty = async (PartyId: number | string) => {
    const numericId = typeof PartyId === "number" ? PartyId : resolvePartyIdToNumber(PartyId);
    if (numericId == null) {
      setFilteredNominations([]);
      return;
    }
    try {
      setLoader2(true);
      const response = await fetchWrapper.get(
        `get-party-nomination-type-by-id?PartyId=${numericId}`
      );
      if (response.isSuccess) {
        setFilteredNominations(response.value.nominationList || []);
      } else {
        setFilteredNominations([]);
      }
    } catch (err) {
      console.error("Failed to fetch nominations", err);
      setFilteredNominations([]);
    } finally {
      setLoader2(false);
    }
  };

  const getContainersByVir = async (vir: string) => {
    try {
      setLoader2(true);
      const results: any = await fetchWrapper.get(`get-released-vir-indexes/${vir}`);
      if (results.isSuccess) {
        setVirContainerList(results.value?.indexesList);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setIsOpenDeleteDailog(false);
  };

  const handleDeleteDialog = () => {
    setIsOpenDeleteDailog(false);
    dispatch(removeGridItem(deleteGridItemId));
  };

  const handleRemoveGridItem = (params: any) => {
    setIsOpenDeleteDailog(true);
    setDeleteGridItemId(params.id);
  };
  const getVehicleContainerNumbers = async () => {
    setLoader2(true);
    const results = await fetchWrapper.get("get-all-vehicles-and-containers-for-gate-out");
    setVirContainerList(results.value?.containerList);
    setLoader2(false);

    if (results.isSuccess) {
      setVehicleContanerNumbers(results.value);
    }
    return;
  };
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        // indexNumber: Yup.string().when("isOpenTruck", {
        //   is: false,
        //   then: (schema) => schema.required("This field is required"),
        //   otherwise: (schema) => schema.notRequired(),
        // }),
        virNumber: Yup.string().test(
          "virNumber-required",
          "This field is required",
          function (value) {
            const { isOpenTruck } = this.parent;
            if (isOpenTruck || isExportMode) return true;
            return Boolean(value);
          }
        ),
        // GD number input is no longer available in the form; keep it optional to avoid blocking submit
        gdNumber: Yup.string(),
        containerNumber: Yup.string().when("isOpenTruck", {
          is: false,
          then: (schema) => schema.required("This field is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        vehicleNumber: Yup.string().test(
          "vehicleNumber-required",
          "This field is required",
          function (value) {
            const { isOpenTruck } = this.parent;
            if (isOpenTruck) return Boolean(value);
            if (isExportMode && !isOpenTruck) return Boolean(value);
            return true;
          }
        ),
        paymentType: Yup.string().required("This field is required"),
        paymentQuantity: Yup.number()
          .required("This field is required")
          .max(10000000000, "Maximum 10 digits are allowed")
          .test(
            "Is positive?",
            "The Quantity must be equal or greater than 0.",
            (value: any) => value > -1
          ),
        discount: Yup.number()
          .max(10000000000, "Maximum 10 digits are allowed")
          .test(
            "Is positive?",
            "The discount must be equal or greater than 0.",
            (value: any) => value > -1
          ),
        charges: Yup.number()
          .required("This field is required")
          .max(1000000000000000, "Maximum 15 digits are allowed")
          .test(
            "Is positive?",
            "The Charges must be equal or greater than 0.",
            (value: any) => value > -1
          ),
        remarks: Yup.string().max(3000, "Maximum 3000 characters allowed"),
      }),
    [isExportMode]
  );

  const formik = useFormik({
    initialValues: {
      gatePassId: "",
      containerNumber: "",
      virNumber: "",
      indexNumber: "",
      vehicleNumber: "",
      currency: "PKR",
      paymentTypeId: 0,
      paymentType: "",
      isFixed: 0,
      otherPaymentName: "",
      paymentQuantity: 1,
      charges: "",
      remarks: "",
      taxTypeId: "",
      discount: 0,
      tax: { taxType: "", taxRate: 0 },
      isOpenTruck: false,
      PartyId: "",
      NominationId: "",
      nominationName: "",
      importer: "",
      gdNumber: "",
      discountApplied: false,
      discountPercentage: 0,
      agentNameId: 0,
      challanNumber: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (extraValidations(values, isOtherPayment) === false) return;
      const temp = values.paymentType;
      if (isOtherPayment) values.paymentType = values.otherPaymentName;

      // Calculate discount and charges after discount for terminalType == 4
      let chargesAfterDiscount = 0;
      let discountAmount = 0;
      const originalChargesAmount =
        originalCharges > 0 ? originalCharges : Number(values.charges) || 0;

      if (terminalType === 4 && discountApplied && discountPercentage > 0 && originalCharges > 0) {
        discountAmount = Math.round((originalCharges * discountPercentage) / 100);
        chargesAfterDiscount = Math.round(originalCharges - discountAmount);
      } else {
        chargesAfterDiscount = Math.round(originalChargesAmount);
      }

      const obj = {
        IndexNo: values.indexNumber,
        currency: values.currency,
        paymentTypeId: values.paymentTypeId,
        paymentType: values.paymentType,
        isFixed: values.isFixed,
        otherPaymentName: values.otherPaymentName,
        paymentQuantity: values.paymentQuantity,
        charges:
          terminalType === 4 && discountApplied && originalCharges > 0
            ? chargesAfterDiscount
            : Math.round(originalChargesAmount),
        discount:
          terminalType === 4 && discountApplied && originalCharges > 0
            ? Math.round(discountAmount)
            : 0,
        discountedCharges:
          terminalType === 4 && discountApplied && originalCharges > 0
            ? Math.round(originalCharges)
            : Math.round(originalChargesAmount),
      };
      const res: any = await dispatch(addPaymentAction(obj));
      setVehicleAdd(true);
      if (res.payload) {
        values.paymentType = temp;
        actions.setSubmitting(false);
        setIsDirty(false);
        resetFilterForm();
        setOriginalCharges(0);
        return;
      }
    },
  });

  const extraValidations = (values: any, isOtherPayment: boolean) => {
    if (isOtherPayment) {
      if (values.otherPaymentName === "") {
        dispatch(
          addNotificationAction({
            message: "Other Payment Name is Required",
            options: { variant: "error" },
          })
        );
        return false;
      }
    }
    return true;
  };

  const resetWholePage = (retainToggle = false) => {
    const currentIsOpenTruck = formik.values.isOpenTruck;

    formik.resetForm({
      values: {
        ...formik.initialValues,
        isOpenTruck: retainToggle ? currentIsOpenTruck : formik.initialValues.isOpenTruck,
      },
    });

    setVehicleAdd(false);
    setatCommercialStation(false);
    dispatch(removeAllPayments());
    setApiSubmitRecordData([]);
    setFilterGridRecord([]);
    setTotalAmount(0);
    setVirContainerList([]);
    setContainerDetails([]);
    setnominationDetails({});
    setFilteredNominations([]);
    setNumberOfCbm(0);
    setStayDays(0);
    setVehicleStatusData({});
    setDiscountApplied(false);
    setDiscountPercentage(0);
    setOriginalCharges(0);
    if (isExportMode) {
      setGdVehiclesList([]);
      setGdContainerList([]);
    }
  };

  useEffect(() => {
    resetWholePage(true); // Retain toggle value
  }, [formik.values.isOpenTruck]);
  console.log("formik.values.isOpenTruck", formik.values.isOpenTruck);
  useEffect(() => {
    dispatch(getAllPartName(true));
    dispatch(getAllAgents(true));
    formik.setFieldValue("charges", "");
  }, []);
  const allAgetns = useAppSelector(selectAllAgent);

  const resetFilterForm = () => {
    formik.resetForm();
    formik.setValues({
      ...formik.initialValues,
      remarks: formik.values.remarks,
      gatePassId: formik.values.gatePassId,
      containerNumber: formik.values.containerNumber,
      virNumber: formik.values.virNumber,
      indexNumber: formik.values.indexNumber,
      vehicleNumber: formik.values.vehicleNumber,
      taxTypeId: formik.values.taxTypeId,
      discount: formik.values.discount,
      tax: formik.values.tax,
      charges: formik.values.charges,
      gdNumber: formik.values.gdNumber,
      agentNameId: formik.values.agentNameId,
    });
    setIsDirty(false);
    setIsOtherPayment(false);
    setDiscountApplied(false);
    setDiscountPercentage(0);
    setOriginalCharges(0);
    setOriginalCharges(0);
    if (isExportMode) {
      setGdVehiclesList([]);
      setGdContainerList([]);
    }
  };

  const GroupHeader = styled("div")(({}) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    fontWeight: "bold",
    backgroundColor: "#E7E7E7",
  }));

  const GroupItems = styled("ul")({
    padding: 0,
  });

  const recordSaveHandler = () => {
    let grossTotal = 0;
    let discountTotal = 0;

    if (weightScanTypesRecord) {
      const newData = weightScanTypesRecord.map((item: any) => {
        const quantity = item.paymentQuantity || 1;
        const discountPerUnit = item.discount || 0;
        const totalDiscount = discountPerUnit * quantity;

        // For terminalType == 4, charges is already discounted, so use discountedCharges for gross total
        // Otherwise, charges is the original amount
        let totalCharges = 0;
        if (terminalType === 4 && item.discountedCharges !== undefined) {
          // Use original charges (discountedCharges) for gross total calculation
          totalCharges = item.discountedCharges * quantity;
        } else {
          // For non-terminalType 4, charges is the original amount
          totalCharges = item.charges * quantity;
        }

        grossTotal += totalCharges; // gross before discount
        discountTotal += totalDiscount;

        return {
          ...item,
          charges: `${item.currency} ${numberFormatting(totalCharges)} `,
          chargesPerUnit: item.charges, // Preserve original charges per unit for calculations
          discount: item.discount || 0,
          discountedCharges:
            terminalType === 4 && item.discountedCharges !== undefined
              ? item.discountedCharges
              : item.charges, // Store original charges for Discount Total calculation
        };
      });

      setTotalAmount(grossTotal);
      // keep the form-level discount in sync with line-level discounts
      formik.setFieldValue("discount", discountTotal);
      setFilterGridRecord(newData);

      const newData2 = weightScanTypesRecord.map((item: any) => {
        const quantity = item.paymentQuantity || 1;
        const chargesPerUnit = item.charges || 0; // This is already discounted if discount was applied
        const discountPerUnit = item.discount || 0;
        // discountedCharges is the original amount without discount
        const originalChargesPerUnit =
          terminalType === 4 && item.discountedCharges !== undefined
            ? item.discountedCharges
            : chargesPerUnit;

        return {
          ...item,
          charges: Math.round(chargesPerUnit * quantity), // charges after discount (for terminalType == 4)
          discount: Math.round(discountPerUnit * quantity),
          discountedCharges: Math.round(originalChargesPerUnit * quantity), // original charges without discount
        };
      });
      setApiSubmitRecordData(newData2);
    }
  };
  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleConfirmDialog = async () => {
    const hasDemurrage = filterGridRecord.some((item: any) => {
      const paymentTypeStr = item.paymentType?.toString();

      return paymentTypeStr.toLowerCase().includes("demurrage");
    });
    const hasDG = filterGridRecord.some((item: any) => {
      const paymentTypeStr = item.paymentType?.toString();

      return paymentTypeStr.toLowerCase().includes("dg");
    });
    const hasStorage = filterGridRecord.some((item: any) => {
      // Check possible places where the payment type name might be
      const paymentTypeStr = item.paymentType?.toString();

      return paymentTypeStr.toLowerCase().includes("storage");
    });
    if (containerDetails?.noOfDemurrageDays > 0 && terminalType !== 4 && !hasDemurrage) {
      alert(
        "Container has exceeded the 5-day grace period days. Please handle port demurrage charges."
      );
      return; // stop execution
    }
    if (containerDetails?.cargoType == "DG" && !hasDG) {
      alert("Cargo type is DG Add the DG Charges in the Payment Record before proceeding.");
      return; // stop execution
    }
    if (storageDays > 0 && !hasStorage) {
      alert(
        `Index has exceeded the grace period (${storageDays} day(s)). Please handle storage charges.`
      );
      return; // stop execution
    }
    setIsOpen(false);

    // Calculate total discount: individual payment type discounts + overall discount
    let totalDiscount = Number(formik.values.discount) || 0; // Overall discount from bottom section
    // For terminalType == 4, also add individual payment type discounts
    if (terminalType === 4 && apiSubmitRecordData.length > 0) {
      const paymentDetailDiscounts = apiSubmitRecordData.reduce((sum: number, item: any) => {
        const itemDiscount =
          typeof item.discount === "string" ? parseFloat(item.discount) || 0 : item.discount || 0;
        return sum + itemDiscount;
      }, 0);
      totalDiscount += paymentDetailDiscounts;
    }

    // Calculate net amount with all discounts
    const amount = Number(totalAmount) || 0;
    const taxRate = Number(formik.values.tax.taxRate) || 0;
    const calculatedTaxAmount = (amount * taxRate) / 100;
    const finalNetAmount = amount + calculatedTaxAmount - totalDiscount;
    const record = {
      vehicleNumber: formik.values.vehicleNumber,
      gatePassId: formik.values.gatePassId,
      virNo: isExportMode ? formik.values.gdNumber : formik.values.virNumber,
      atCommercialStation: atCommercialStation,
      gatePassPaymentDetail: apiSubmitRecordData,
      remarks: formik.values.remarks,
      containerNumber: formik.values.containerNumber,
      taxId: formik.values.taxTypeId,
      discount: Number(formik.values.discount) || 0, // Send only overall discount, individual discounts are in gatePassPaymentDetail
      taxAmount: calculatedTaxAmount,
      taxRate: formik.values.tax.taxRate,
      netAmount: finalNetAmount,
      totalAmount: totalAmount,
      nomination: nominationDetails.name,
      agentId: formik.values.agentNameId,
      partyId: (() => {
        const raw = formik.values.PartyId || containerDetails?.forwarder || "";
        if (raw === "") return "";
        const num = Number(raw);
        if (!Number.isNaN(num) && num > 0) return num;
        const byName = allPartyNameRows.find(
          (p: any) => (p.name && String(p.name).trim()) === String(raw).trim()
        );
        const id = (byName as any)?.id;
        return id ?? (typeof raw === "number" ? raw : 0);
      })(),
    };
    const res: any = await dispatch(postTerminalChargesWholeRecordAction(record));
    if (res?.payload) {
      resetWholePage();
      formik.setFieldValue("remarks", "");
    }
  };

  const submitCompletePage = async () => {
    if (!apiSubmitRecordData.length) {
      dispatch(
        addNotificationAction({
          message: "Please add some Payment record!",
          options: { variant: "error" },
        })
      );
      return;
    }

    let data = "";
    apiSubmitRecordData.forEach((item: any) => {
      data = data.concat(
        `${item.paymentType}: ${item.currency} ${numberFormatting(item.charges)} #`
      );
    });
    // Show net amount (after discount) if discount is applied, otherwise show total amount
    const displayAmount = calculateNetAmount();
    data = data.concat(
      ` Total Charges: ${formik.values.currency} ${numberFormatting(displayAmount)}`
    );
    setDialogContent(data);
    setIsOpen(true);
  };

  function handleChange(e: any) {
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      !loading && submitCompletePage();
    }
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Type of Payment": data?.paymentType,
        Quantity: data?.paymentQuantity,
        "Total Charges": `PKR ${data?.charges?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
      };
    });
    return exportedRecords;
  };

  const handleCloseDublicateDialog = () => {
    setIsOpenDublicateDailog(false);
    const deleteGridItemId: any = weightScanTypesRecord[weightScanTypesRecord.length - 1];
    dispatch(removeGridItem(deleteGridItemId.id));
  };

  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Closes the duplicate dialog and triggers the record save handler.
   * This function is asynchronous and ensures the dialog is closed
   * before proceeding to handle the record saving logic.
   */

  /*******  60c74571-e947-4317-93dd-71e3261aa549  *******/
  const handleSaveDublicateDialog = async () => {
    setIsOpenDublicateDailog(false);
    recordSaveHandler();
  };

  function calculateNetAmount() {
    const amount = Number(totalAmount) || 0;
    const taxRate = Number(formik.values.tax.taxRate) || 0;

    // Calculate total discount: individual payment type discounts + overall discount
    let totalDiscount = Number(formik.values.discount) || 0; // Overall discount from bottom section

    // For terminalType == 4, also add individual payment type discounts
    if (terminalType === 4 && apiSubmitRecordData.length > 0) {
      const paymentDetailDiscounts = apiSubmitRecordData.reduce((sum: number, item: any) => {
        const itemDiscount =
          typeof item.discount === "string" ? parseFloat(item.discount) || 0 : item.discount || 0;
        return sum + itemDiscount;
      }, 0);
      totalDiscount += paymentDetailDiscounts;
    }

    const taxAmount = (amount * taxRate) / 100;

    // Calculate net amount: gross total + tax - all discounts
    const netAmount = amount + taxAmount - totalDiscount;

    return netAmount;
  }
  function calculateTax() {
    const tax = Number(totalAmount) * (Number(formik.values.tax.taxRate) / 100);
    return tax;
  }

  const fetchPendingContainers = async () => {
    setPendingContainerList([]);
    try {
      const results = await fetchWrapper.post("get-all-released-virs", {});
      if (results.isSuccess) {
        setPendingContainerList(results.value.list);
      }
      return;
    } catch (error) {}
  };
  const calculateStorageCharge = (slabs: any[], totalStorageDays: number, freeDays: number) => {
    const chargeableDays = Math.max(0, totalStorageDays - freeDays);
    if (chargeableDays === 0) return 0; // no charge if all free

    let charge = 0;
    const chargeStartDay = freeDays + 1; // first chargeable day

    for (const slab of slabs) {
      // Overlap between slab and chargeable days
      const start = Math.max(slab.dayStart, chargeStartDay);
      const end = Math.min(slab.dayEnd, totalStorageDays);

      if (end >= start) {
        const daysInSlab = end - start + 1;
        charge += daysInSlab * slab.charges;
      }
    }
    return charge;
  };
  const fetchStorageSlabs = async (type: any) => {
    try {
      const results = await fetchWrapper.get(
        `get-storage-slabs_by_type?Type=${type}&IsActive=true`
      );
      if (results.isSuccess && results.value?.slabs) {
        // Handle the slabsList as needed (e.g., set to state)
        setStorageSlabs(results.value.slabs);
        return results.value.slabs;
      }
    } catch (error) {
      console.error("Error fetching storage slabs:", error);
    }
  };

  const getContailerDetails = async (indexNumber: any, gatePassId: any) => {
    setContainerDetails([]);
    setLoader2(true);

    try {
      const results = await fetchWrapper.get(
        `get-container-detail/${gatePassId}/index_no/${indexNumber}`
      );
      if (results.isSuccess) {
        setContainerDetails(results.value);
        const forwarder = results.value?.forwarder || "";
        formik.setFieldValue("PartyId", forwarder);
        await getNominationsByParty(forwarder);
      }
      setLoader2(false);
      return;
    } catch (error) {
      setLoader2(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [apiSubmitRecordData, loading]);

  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  useEffect(() => {
    const isPaymentExist = weightScanTypesRecord?.filter(
      (rec: any) => rec.paymentTypeId == formik.values.paymentTypeId
    ).length;
    if (isPaymentExist > 1) {
      setIsOpenDublicateDailog(true);
      return;
    }
    recordSaveHandler();
  }, [weightScanTypesRecord]);
  useEffect(() => {
    if (terminalType === 4) {
      getVehicleContainerNumbers();
      document.addEventListener("keydown", listener);
      return () => {
        document.removeEventListener("keydown", listener);
      };
    }
  }, []);
  useEffect(() => {
    (async () => {
      // const storagePaymentType = paymentTypeDetail?.name?.toLowerCase().includes("storage");
      if (paymentTypeDetail && terminalType !== 4) {
        // const indexCbm = containerDetails?.billingCBM || numberOfCbm || 0;
        // const nominationObj = nominationDetails || {};
        const paymentName = paymentTypeDetail.name;
        if (paymentName === "Port Demurrage Charges") {
          const totalIndexes = containerDetails?.totalIndexes || 1;
          const noOfDemurrageDays = containerDetails?.noOfDemurrageDays || 0;
          const amountPerContainer = paymentTypeDetail?.amount / totalIndexes;
          const finalAmount = Math.round(amountPerContainer * noOfDemurrageDays);

          formik.setFieldValue("charges", finalAmount);
          setOriginalCharges(finalAmount);
        } else if (paymentName === "Detention Charges") {
          const unpaidCount = containerDetails?.unpaidIndexCount || 1;
          const amount = Math.round((paymentTypeDetail?.amount || 0) / unpaidCount);
          formik.setFieldValue("charges", amount);
          setOriginalCharges(amount);
          // Calculate Storage Charges
        } else {
          formik.setFieldValue("charges", paymentTypeDetail?.amount);
          setOriginalCharges(paymentTypeDetail?.amount || 0);
        }
        // formik.setFieldValue("charges", paymentTypeDetail.amount);
      } else {
        const amount = paymentTypeDetail?.amount || 0;
        formik.setFieldValue("charges", amount);
        setOriginalCharges(amount);
      }
    })();
  }, [paymentTypeDetail]);
  useEffect(() => {
    setOriginalCharges(0);
    formik.setFieldValue("charges", "");
  }, []);
  useEffect(() => {
    const destuffDateStr = containerDetails?.destuffingDate;
    const gateinDate = containerDetails?.gateInDate || containerDetails?.createdDateTime;
    let storageDays = 0;
    if (containerDetails?.containerType === "CY") {
      if (gateinDate) {
        const createdDate = new Date(gateinDate);
        const today = new Date();

        // Remove the +5 grace days
        const diffTime = today.getTime() - createdDate.getTime();

        storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      }
    } else {
      if (destuffDateStr) {
        const createdDate = new Date(destuffDateStr);
        const today = new Date();

        // Remove the +5 grace days
        const diffTime = today.getTime() - createdDate.getTime();

        storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      }
    }
    setStorageDays(storageDays);
  }, [containerDetails]);

  useEffect(() => {
    const isPaymentExist = weightScanTypesRecord?.filter(
      (rec: any) => rec.paymentTypeId == formik.values.paymentTypeId
    ).length;
    if (isPaymentExist > 1) {
      setIsOpenDublicateDailog(true);
      return;
    }
    recordSaveHandler();
  }, [weightScanTypesRecord]);

  useEffect(() => {
    const list = [
      ...paymentTypes.filter((item: any) => item.isFixed == 1),
      ...paymentTypes.filter((item: any) => item.isFixed == 0),
    ];
    setPaymentTypesList(
      list.concat({
        amount: 0,
        currency: "PKR",
        id: -1,
        isActive: true,
        isFixed: 0,
        name: "Other",
      })
    );
  }, [paymentTypes]);

  useEffect(() => {
    // Filter out discount and discountTotal columns if terminalType !== 4
    const filteredColumns =
      terminalType === 4
        ? columns
        : columns.filter(
            (column: any) =>
              column.accessorKey !== "discount" && column.accessorKey !== "discountTotal"
          );

    const transformedColumns: any = filteredColumns.map((column: any) =>
      column.accessorKey === "actionButtons"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <>
                  <NewCommonButton
                    icon={<DeleteIcon />}
                    isDelete={true}
                    onClick={() => {
                      handleRemoveGridItem(row.original);
                    }}
                  >
                    Delete
                  </NewCommonButton>
                </>
              );
            },
          }
        : column
    );
    setDisplayColumns(transformedColumns);
  }, [terminalType]);

  useEffect(() => {
    dispatch(getPaymentTypesDropdownAction());
    fetchPendingContainers();
    dispatch(getAllTaxTypes(1));
    if (isExportMode) {
      getVehicleGDs();
    }
  }, [isExportMode]);
  // Helper function to calculate tariff payment charges
  const calculateTariffPayment = async (values: any, actions: any) => {
    if (extraValidations(values, isOtherPayment) === false) return;
    const payment = paymentTypesList.find((pt: any) => pt.name === "Tarrif Payment");
    const indexCbm = containerDetails?.billingCBM || numberOfCbm || 0;
    const nominationObj = nominationDetails || {};

    const trackingChargesPerIndex =
      nominationObj.trackingCharges > 0
        ? nominationObj.trackingCharges / (containerDetails?.totalIndexes || 1)
        : 0;

    const amount = Math.round(
      (nominationObj.perCbm || 0) * indexCbm +
        // (nominationObj.terminalHandlingCharges || 0) * indexCbm +
        (nominationObj.terminalHandlingCharges || 0) * (indexCbm > 0 ? indexCbm : 1) +
        (nominationObj.perIndex || 0) +
        (nominationObj.documentationCharges || 0) +
        (nominationObj.fuelCharges || 0) +
        trackingChargesPerIndex
    );
    const temp = payment.name;
    if (isOtherPayment) payment.name = values.otherPaymentName;

    const obj = {
      IndexNo: values.indexNumber,
      currency: values.currency,
      paymentTypeId: payment.id,
      paymentType: payment.name,
      isFixed: payment.isFixed,
      otherPaymentName: values.otherPaymentName || "",
      paymentQuantity: values.paymentQuantity,
      charges: amount,
    };

    const res: any = await dispatch(addPaymentAction(obj));
    setVehicleAdd(true);

    if (res.payload) {
      values.paymentType = temp;
      actions.setSubmitting(false);
      setIsDirty(false);
      resetFilterForm();
      return;
    }
  };
  // Helper function to calculate Examination payment charges
  const calculateExaminationCharges = async (values: any, actions: any) => {
    if (extraValidations(values, isOtherPayment) === false) return;
    const payment = paymentTypesList.find((pt: any) => pt.name === "Examination Charges");
    const temp = payment.name;
    if (isOtherPayment) payment.name = values.otherPaymentName;

    const obj = {
      IndexNo: values.indexNumber,
      currency: values.currency,
      paymentTypeId: payment.id,
      paymentType: payment.name,
      isFixed: payment.isFixed,
      otherPaymentName: values.otherPaymentName || "",
      paymentQuantity: values.paymentQuantity,
      charges: payment.amount,
    };

    const res: any = await dispatch(addPaymentAction(obj));
    setVehicleAdd(true);

    if (res.payload) {
      values.paymentType = temp;
      actions.setSubmitting(false);
      setIsDirty(false);
      resetFilterForm();
      return;
    }
  };
  const calculateStoragePayment = async (values: any, actions: any) => {
    let amount = 0;
    //storage charges for CY containers
    if (!isExportMode) {
      if (containerDetails?.containerType === "CY") {
        const gateInDate = new Date(containerDetails?.gateInDate); // example gate-in date
        const currentDate = new Date(); // today's date

        // Calculate difference in milliseconds
        const diffInMs = currentDate.getTime() - gateInDate.getTime();
        const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (containerDetails?.containerSize === 45) {
          const slabs = await fetchStorageSlabs("CY45");
          amount = calculateStorageCharge(slabs, diffDays, 10);
        }
        if (containerDetails?.containerSize === 40) {
          const slabs = await fetchStorageSlabs("CY40");
          amount = calculateStorageCharge(slabs, diffDays, 10);
        }
        if (containerDetails?.containerSize === 20) {
          const slabs = await fetchStorageSlabs("CY20");
          amount = calculateStorageCharge(slabs, diffDays, 10);
        }
      }
      //storage charges for CFS containers
      if (containerDetails?.containerType === "CFS") {
        const gateInDate = new Date(containerDetails?.destuffingDate); // example gate-in date
        const currentDate = new Date(); // today's date

        // Calculate difference in milliseconds
        const diffInMs = currentDate.getTime() - gateInDate.getTime();
        const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (containerDetails?.cargoType === "DG") {
          const slabs = await fetchStorageSlabs("CFS LCL(DG)");
          amount = calculateStorageCharge(slabs, diffDays, 3);
        }
        if (containerDetails?.cargoType === "General") {
          const slabs = await fetchStorageSlabs("CFS LCL(General)");
          amount = calculateStorageCharge(slabs, diffDays, 5);
        }
        if (containerDetails?.cargoType === "Cars") {
          const slabs = await fetchStorageSlabs("CFS Car");
          amount = calculateStorageCharge(slabs, diffDays, 12);
        }
      }
      if (containerDetails?.containerType === "CFS Scrap") {
        const gateInDate = new Date(containerDetails?.createdDateTime); // example gate-in date
        const currentDate = new Date(); // today's date

        // Calculate difference in milliseconds
        const diffInMs = currentDate.getTime() - gateInDate.getTime();
        const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        if (diffDays > 37) {
          const billableDays = diffDays - 37;
          amount = billableDays * 80 * (containerDetails.cargoWeight / 1000);
        }
      }
    }

    //storage charges for CFS LCL(General) Export mode
    if (isExportMode) {
      const gateInDate = new Date(vehicleStatusData?.dateTime); // example gate-in date
      const currentDate = new Date(); // today's date

      // Calculate difference in milliseconds
      const diffInMs = currentDate.getTime() - gateInDate.getTime();
      const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

      if (vehicleStatusData?.cargoType === "LOOSE CARGO") {
        const slabs = await fetchStorageSlabs("CFS LCL(General)");
        amount = calculateStorageCharge(slabs, diffDays, 5);
      }
    }
    //storage charges end for CFS LCL(General) Export mode
    //storage charges for CY containers EXport mode
    if (isExportMode && vehicleStatusData?.containerType) {
      const gateInDate = new Date(vehicleStatusData?.dateTime);
      const currentDate = new Date();

      // Calculate difference in days
      const diffInMs = currentDate.getTime() - gateInDate.getTime();
      const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

      let slabKey = "";
      let freeDays = 5; // default for General

      // Determine slab key based on container type and size
      if (vehicleStatusData.cargoType === "GENERAL") {
        if (vehicleStatusData.containerSize === 45) slabKey = "CY45";
        if (vehicleStatusData.containerSize === 40) slabKey = "CY40";
        if (vehicleStatusData.containerSize === 20) slabKey = "CY20";
      }

      if (vehicleStatusData.cargoType === "DG") {
        freeDays = 2;
        if (vehicleStatusData.containerSize === 45) slabKey = "CY(DG)45";
        if (vehicleStatusData.containerSize === 40) slabKey = "CY(DG)40";
        if (vehicleStatusData.containerSize === 20) slabKey = "CY(DG)20";
      }

      if (slabKey) {
        const slabs = await fetchStorageSlabs(slabKey);
        amount = calculateStorageCharge(slabs, diffDays, freeDays);
      }
    }

    //storage charges end for CY containers EXport mode
    if (extraValidations(values, isOtherPayment) === false) return;
    const payment = paymentTypesList.find((pt: any) => pt.name === "Storage Charges");
    const temp = payment.name;
    if (isOtherPayment) payment.name = values.otherPaymentName;
    const obj = {
      IndexNo: values.indexNumber,
      currency: values.currency,
      paymentTypeId: payment.id,
      paymentType: payment.name,
      isFixed: payment.isFixed,
      otherPaymentName: values.otherPaymentName || "",
      paymentQuantity: values.paymentQuantity,
      charges: amount,
    };

    const res: any = await dispatch(addPaymentAction(obj));
    setVehicleAdd(true);

    if (res.payload) {
      values.paymentType = temp;
      actions.setSubmitting(false);
      setIsDirty(false);
      resetFilterForm();
      return;
    }
  };
  const calculateDGCargoPayment = async (values: any, actions: any) => {
    if (extraValidations(values, isOtherPayment) === false) return;
    const payment = paymentTypesList.find((pt: any) => pt.name === "DG Cargo Payment");
    const temp = payment.name;
    if (isOtherPayment) payment.name = values.otherPaymentName;

    const obj = {
      IndexNo: values.indexNumber,
      currency: values.currency,
      paymentTypeId: payment.id,
      paymentType: payment.name,
      isFixed: payment.isFixed,
      otherPaymentName: values.otherPaymentName || "",
      paymentQuantity: values.paymentQuantity,
      charges: payment.amount,
    };

    const res: any = await dispatch(addPaymentAction(obj));
    setVehicleAdd(true);

    if (res.payload) {
      values.paymentType = temp;
      actions.setSubmitting(false);
      setIsDirty(false);
      resetFilterForm();
      return;
    }
  };

  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };
  // ADD THIS FUNCTION FROM SCENARIO 2
  const getVehicleStatusByVehicleId = async (id: number) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);

      if (results.isSuccess) {
        // Store full vehicle status data
        setVehicleStatusData(results.value || {});
        // setcargoType(results.value.cargoTypeName);
        // setconsignmentType(results.value.consignmentTypeName);
        // setvehicleType(results.value.vehicleType);
        // setentryDateTime(results.value.dateTime);
        // setScanning(results.value.isScanComplete);
        // setWeight(results.value.isWeightDone);
        // Pre-fill container number and gate pass for export flow
        const containerNumber = results.value.containerNumber || "";
        const gatePassId = results.value.gatePassIds || "";
        if (containerNumber && isExportMode) {
          formik.setFieldValue("containerNumber", containerNumber);
          formik.setFieldValue("gatePassId", gatePassId);
          setGdContainerList([{ containerNumber, gatePassId }]);
        } else if (!isExportMode) {
          setGdContainerList([]);
        }
      }
    } finally {
      setLoader2(false);
    }
  };
  const getVehicleGDs = async () => {
    try {
      setLoader2(true);
      const results = await fetchWrapper.post("get-all-pending-gds", {});
      if (results.isSuccess) {
        setGdList(results.value.getAllPendingGds || []);
      }
    } catch (error) {
      console.error("Failed to fetch GD list", error);
    } finally {
      setLoader2(false);
    }
  };

  // const getVehiclesByGD = async (gdNo: string) => {
  //   try {
  //     setLoader2(true);
  //     const results = await fetchWrapper.post("get-all-details-by-gd", { gdNo });
  //     if (results.isSuccess) {
  //       setGdVehiclesList(results.value.getAllVehicleNumbers || []);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch vehicles by GD", error);
  //     setGdVehiclesList([]);
  //   } finally {
  //     setLoader2(false);
  //   }
  // };

  // const getContainersByVehicleAndGD = async (vehicleNumber: string, gdNo: string) => {
  //   try {
  //     setLoader2(true);
  //     const results = await fetchWrapper.post("get-all-containsers-by-gd-or-vir", {
  //       id: vehicleNumber,
  //       consignmentType: "Export",
  //       virNo: gdNo,
  //       isEdit: false,
  //     });
  //     if (results.isSuccess) {
  //       const containers = results.value.containersList || [];
  //       setGdContainerList(containers);
  //       // Auto-populate container number if only one container
  //       if (containers.length === 1) {
  //         formik.setFieldValue("containerNumber", containers[0].containerNumber || "");
  //         formik.setFieldValue("gatePassId", containers[0].gatePassId || "");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch containers", error);
  //     setGdContainerList([]);
  //   } finally {
  //     setLoader2(false);
  //   }
  // };
  const checkStorageCharges = (row: any) => {
    const destuffDateStr = containerDetails?.destuffingDate;
    const gateinDate = containerDetails?.gateInDate || containerDetails?.createdDateTime;
    let storageDays = 0;
    if (destuffDateStr || gateinDate) {
      if (containerDetails?.containerType === "CY") {
        const createdDate = new Date(gateinDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Remove the +5 grace days
        const diffTime = today.getTime() - createdDate.getTime();

        storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      } else {
        const createdDate = new Date(destuffDateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Remove the +5 grace days
        const diffTime = today.getTime() - createdDate.getTime();

        storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      }
    }
    setStorageDays(storageDays);
    formik.setFieldValue("containerNumber", row?.containerNumber);
    formik.setFieldValue("gatePassId", row?.gateEntryId);
    setContainerDetails(row || {});
  };
  const renderContainerNumberField = () => (
    <Grid item xs={12} md={6}>
      <Box>
        <CommonAutoCompleteField
          required={!formik.values.isOpenTruck}
          cssClassName="customTextField"
          label="Container Number"
          placeholder="Select Container Number"
          name="containerNumber"
          optionsType={virContainerList}
          disabled={terminalType !== 4}
          getOptionLabel={(option) => option.containerNumber?.toString()}
          onChange={(row: any) => {
            formik.setFieldValue("containerNumber", row?.containerNumber || "");
            formik.setFieldValue("gatePassId", row?.gateEntryId || "");
            //  Auto-populate VUR and Vehicle numbers
            formik.setFieldValue("virNumber", row?.virNo || "");
            formik.setFieldValue("vehicleNumber", row?.vehicleRegNumber || "");
            const partyName = row?.forwarder || row?.forwarderName || row?.partyName || "";
            formik.setFieldValue("PartyId", partyName);
            getNominationsByParty(partyName);
            formik.setFieldValue("importer", row?.importer || "");

            setContainerDetails(row || {});
            if (row && row.containerNumber != "" && terminalType !== 4) {
              formik.setFieldValue("containerNumber", row?.containerNumber);
              setContainerDetails([]);
              formik.setFieldValue("indexNumber", "");
            }
            if (terminalType !== 4) {
              checkStorageCharges(row);
            }
          }}
          value={
            virContainerList.find(
              (st: any) => st.containerNumber === formik.values.containerNumber
            ) || null
          }
          error={formik.touched.containerNumber && Boolean(formik.errors.containerNumber)}
          helperText={formik.touched.containerNumber && formik.errors.containerNumber}
        />
      </Box>
    </Grid>
  );
  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={NodCommercialRoute.path} />
      <Backdrop className={classes.backdrop} open={loading || loader2}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.isOpenTruck)}
                      onChange={formik.handleChange}
                      name="isOpenTruck"
                      color="primary"
                    />
                  }
                  label="Open Truck"
                />
                <Box
                  style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "22rem" }}
                >
                  <Typography>Import</Typography>
                  <FormControlLabel
                    style={{ margin: "0px" }}
                    control={
                      <Switch
                        checked={isExportMode}
                        onChange={(e) => {
                          setIsExportMode(e.target.checked);

                          // Always reset shared form fields when toggling modes to avoid carry-over
                          setFilteredNominations([]);
                          setnominationDetails({});
                          setContainerDetails({});
                          setVehicleStatusData({});
                          formik.setFieldValue("PartyId", "");
                          formik.setFieldValue("nominationName", "");
                          formik.setFieldValue("paymentType", "");
                          formik.setFieldValue("paymentQuantity", 1);
                          formik.setFieldValue("otherPaymentName", "");
                          formik.setFieldValue("charges", "");
                          formik.setFieldValue("taxTypeId", "");
                          formik.setFieldValue("remarks", "");

                          if (e.target.checked) {
                            getVehicleGDs();
                            // Clear import-specific fields
                            setVirContainerList([]);
                            formik.setFieldValue("virNumber", "");
                            formik.setFieldValue("indexNumber", "");
                          } else {
                            // Reset export-specific data so old export info doesn't bleed into import
                            setGdList([]);
                            setGdVehiclesList([]);
                            setGdContainerList([]);
                            formik.setFieldValue("gdNumber", "");
                          }

                          // Clear container/vehicle selections for both modes
                          formik.setFieldValue("vehicleNumber", "");
                          formik.setFieldValue("containerNumber", "");
                          formik.setFieldValue("gatePassId", "");
                        }}
                        color="primary"
                      />
                    }
                    label=""
                  />
                  <Typography>Export</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetWholePage()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => submitCompletePage()}
                >
                  Save
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "10px" }}>
            <Divider />
          </Box>

          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={6}>
              <Grid spacing={2} container direction="row">
                {isExportMode ? (
                  <>
                    {/* GD Number - Dropdown */}
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          required={isExportMode && !formik.values.isOpenTruck}
                          disabled={isVehicleAdd || formik.values.isOpenTruck}
                          cssClassName="customTextField"
                          label="Good's Declaration Number (GD#)"
                          placeholder="Select GD#"
                          name="gdNumber"
                          optionsType={gdList}
                          getOptionLabel={(option: any) => option.gdNo || ""}
                          onChange={(e: any) => {
                            const selectedGd = e?.gdNo || "";
                            formik.setFieldValue("gdNumber", selectedGd);
                            formik.setFieldValue("vehicleNumber", "");
                            formik.setFieldValue("containerNumber", "");
                            setGdContainerList([]);
                            if (selectedGd) {
                              getVehiclesByGD(selectedGd);
                            }
                          }}
                          value={
                            gdList.find((st: any) => st.gdNo == formik.values.gdNumber) || null
                          }
                          error={formik.touched.gdNumber && Boolean(formik.errors.gdNumber)}
                          helperText={formik.touched.gdNumber && formik.errors.gdNumber}
                        />
                      </Box>
                    </Grid> */}
                    {/* Container Number - Auto-populated from vehicle */}
                    <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          required={!formik.values.isOpenTruck}
                          cssClassName="customTextField"
                          label="Container Number"
                          placeholder="Select Container Number"
                          name="containerNumber"
                          optionsType={gdContainerList}
                          disabled={terminalType !== 4 || !formik.values.vehicleNumber}
                          getOptionLabel={(option) => option.containerNumber?.toString()}
                          onChange={(row: any) => {
                            formik.setFieldValue("containerNumber", row?.containerNumber || "");
                            formik.setFieldValue("gatePassId", row?.gatePassId || "");
                            setContainerDetails(row || {});
                            if (row && row.containerNumber && terminalType !== 4) {
                              checkStorageCharges(row);
                            }
                          }}
                          value={
                            gdContainerList.find(
                              (st: any) => st.containerNumber === formik.values.containerNumber
                            ) || null
                          }
                          error={
                            formik.touched.containerNumber && Boolean(formik.errors.containerNumber)
                          }
                          helperText={
                            formik.touched.containerNumber && formik.errors.containerNumber
                          }
                        />
                      </Box>
                    </Grid>
                  </>
                ) : terminalType === 4 ? (
                  <>
                    {/* Container Number First */}
                    {renderContainerNumberField()}
                    {/* VIR Number - Manual */}
                    <Grid item xs={12} md={6}>
                      <Box>
                        <TextField
                          // required={!formik.values.isOpenTruck}
                          // disabled={isVehicleAdd || formik.values.isOpenTruck}
                          disabled={terminalType === 4}
                          className="customTextField"
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="VIR Number"
                          placeholder="Enter VIR#"
                          name="virNumber"
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.virNumber}
                          onChange={(e) => {
                            formik.setFieldValue("virNumber", e.target.value);
                          }}
                          // onChange={formik.handleChange}
                          // error={formik.touched.virNumber && Boolean(formik.errors.virNumber)}
                          // helperText={formik.touched.virNumber && formik.errors.virNumber}
                        />
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <>
                    {/* VIR Number - Dropdown */}
                    <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          required={!formik.values.isOpenTruck}
                          disabled={isVehicleAdd || formik.values.isOpenTruck}
                          cssClassName="customTextField"
                          label="VIR Number"
                          placeholder="Select VIR#"
                          name="virNumber"
                          optionsType={pendingContainerList}
                          getOptionLabel={(option: any) => option.id || ""}
                          onChange={(e: any) => {
                            if (!e) {
                              // cleared selection
                              formik.setFieldValue("virNumber", "");
                              formik.setFieldValue("indexNumber", "");
                              formik.setFieldValue("containerNumber", "");
                              setContainerDetails([]);
                              setVirContainerList([]);
                              return;
                            }
                            getContainersByVir(e.id);
                            formik.setFieldValue("virNumber", e.id);
                            setContainerDetails([]);
                            formik.setFieldValue("indexNumber", "");
                            formik.setFieldValue("containerNumber", e?.containerNumber);
                          }}
                          value={
                            pendingContainerList.find(
                              (st: any) => st.id == formik.values.virNumber
                            ) || null
                          }
                          error={formik.touched.virNumber && Boolean(formik.errors.virNumber)}
                          helperText={formik.touched.virNumber && formik.errors.virNumber}
                        />
                      </Box>
                    </Grid>

                    {/* Index Number - Dropdown */}
                    <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          required={!formik.values.isOpenTruck}
                          disabled={isVehicleAdd || formik.values.isOpenTruck}
                          cssClassName="customTextField"
                          label="Index Number"
                          name="indexNumber"
                          placeholder="Select Index Number"
                          optionsType={virContainerList}
                          getOptionLabel={(option) => option.indexNumber?.toString()}
                          onChange={(row: any) => {
                            formik.setFieldValue("indexNumber", row?.indexNumber);
                            formik.setFieldValue("gatePassId", row?.gatePassId);
                            getContailerDetails(row.indexNumber, row?.gatePassId);
                            formik.setFieldValue("containerNumber", row?.containerNumber);
                          }}
                          value={
                            virContainerList.find(
                              (st: any) => st.indexNumber == formik.values.indexNumber
                            ) || null
                          }
                          error={formik.touched.indexNumber && Boolean(formik.errors.indexNumber)}
                          helperText={formik.touched.indexNumber && formik.errors.indexNumber}
                        />
                      </Box>
                    </Grid>
                    {/* Container Number Last */}
                    {renderContainerNumberField()}
                  </>
                )}

                <Grid item xs={12} md={6}>
                  {isExportMode ? (
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Vehicle Number"
                        placeholder="Enter Vehicle Number"
                        name="vehicleNumber"
                        optionsType={vehicleRegNumberArr}
                        getOptionLabel={(option) => option.registrationNumber || ""}
                        required={formik.values.isOpenTruck}
                        value={
                          vehicleRegNumberArr.find(
                            (st: any) => st.registrationNumber == formik.values.vehicleNumber
                          ) || null
                        }
                        onChange={(option: any) => {
                          // your existing logic
                          formik.setFieldValue("vehicleNumber", option.registrationNumber);
                          formik.setFieldValue("gatePassId", option?.gatePassId);

                          // NEW — fetch vehicle status here
                          if (option?.vehicleId) {
                            getVehicleStatusByVehicleId(option.vehicleId);
                          }
                        }}
                        onKeyUp={(e: any) => {
                          setVehicleNumberLength(e.target.value.length);
                          if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                            getVehicleByRegistrationNo(e.target.value);
                            return;
                          }
                        }}
                        error={formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)}
                        helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                      />
                    </Box>
                  ) : (
                    <>
                      <Box style={{ display: formik.values.isOpenTruck ? "none" : "block" }}>
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Vehicle Number"
                          name="vehicleNumber"
                          placeholder="Vehicle Number"
                          disabled={terminalType === 4}
                          value={formik.values.vehicleNumber?.toUpperCase()}
                          onChange={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.nativeEvent.data)) e.preventDefault();
                            else handleChange(e);
                          }}
                          onPaste={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text")))
                              e.preventDefault();
                          }}
                          error={
                            formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)
                          }
                          helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                        />
                      </Box>
                      <Box style={{ display: formik.values.isOpenTruck ? "block" : "none" }}>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Vehicle Number"
                          placeholder="Enter Vehicle Number"
                          name="vehicleNumber"
                          optionsType={vehicleRegNumberArr}
                          getOptionLabel={(option) => option.registrationNumber || ""}
                          required={formik.values.isOpenTruck}
                          value={
                            vehicleRegNumberArr.find(
                              (st: any) => st.registrationNumber == formik.values.vehicleNumber
                            ) || null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("vehicleNumber", option.registrationNumber);
                            formik.setFieldValue("gatePassId", option?.gatePassId);
                            // Fetch vehicle status for inspect mode (non-export)
                            if (option?.vehicleId && !isExportMode) {
                              getVehicleStatusByVehicleId(option.vehicleId);
                            }
                          }}
                          onKeyUp={(e: any) => {
                            setVehicleNumberLength(e.target.value.length);
                            if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                              getVehicleByRegistrationNo(e.target.value);
                              return;
                            }
                          }}
                          // onKeyDownCapture={(e: any) => {
                          //   if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                          //   else handleChange(e);
                          // }}
                          error={
                            formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)
                          }
                          helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                        />
                      </Box>
                    </>
                  )}
                </Grid>
                {!isExportMode && (
                  <Grid item xs={12} md={6}>
                    <Box>
                      {terminalType === 4 ? (
                        // Manual TextField for Party Name (but still using "PartyId" as the name)
                        <TextField
                          className="customTextField"
                          fullWidth
                          disabled={true}
                          size="small"
                          variant="outlined"
                          label="Forwarder Name"
                          placeholder="Enter Forwarder Name"
                          name="PartyId"
                          InputLabelProps={{ shrink: true }}
                          value={formik.values.PartyId}
                          onChange={(e) => {
                            formik.setFieldValue("PartyId", e.target.value);
                          }}
                          error={formik.touched.PartyId && Boolean(formik.errors.PartyId)}
                          helperText={formik.touched.PartyId && formik.errors.PartyId}
                        />
                      ) : (
                        // Dropdown for Party Name
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Party Name"
                          placeholder="Select Party Name"
                          name="PartyId"
                          required
                          optionsType={allPartyNameRows}
                          getOptionLabel={(option) => option.name}
                          value={
                            allPartyNameRows.find((st: any) => st.id === formik.values.PartyId) ||
                            null
                          }
                          onChange={async (option: any) => {
                            const selectedPartyId = option?.id || "";
                            formik.setFieldValue("PartyId", selectedPartyId);
                            formik.setFieldValue("nominationName", "");

                            if (selectedPartyId) {
                              await getNominationsByParty(selectedPartyId);
                            } else {
                              setFilteredNominations([]);
                            }
                          }}
                          error={formik.touched.PartyId && Boolean(formik.errors.PartyId)}
                          helperText={formik.touched.PartyId && formik.errors.PartyId}
                        />
                      )}
                    </Box>
                  </Grid>
                )}
                {terminalType === 4 && (
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className="customTextField"
                        placeholder="Select Importer Name"
                        fullWidth
                        disabled={true}
                        size="small"
                        variant="outlined"
                        label="Importer Name"
                        name="importer"
                        InputLabelProps={{ shrink: true }}
                        value={formik.values.importer}
                        onChange={(e) => {
                          formik.setFieldValue("importer", e.target.value);
                        }}
                        error={formik.touched.importer && Boolean(formik.errors.importer)}
                        helperText={formik.touched.importer && formik.errors.importer}
                      />
                    </Box>
                  </Grid>
                )}
                {terminalType !== 4 && !isExportMode && (
                  <>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Nomination Name"
                          placeholder="Select Nomination"
                          name="nominationName"
                          // required={terminalType !== 4}
                          optionsType={filteredNominations}
                          getOptionLabel={(option) => option.name}
                          value={
                            filteredNominations.find(
                              (nom: any) => nom.name === formik.values.nominationName
                            ) || null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("nominationName", option?.name || "");
                            setnominationDetails(option || {});
                          }}
                          error={
                            formik.touched.nominationName && Boolean(formik.errors.nominationName)
                          }
                          helperText={formik.touched.nominationName && formik.errors.nominationName}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Agent Name"
                          placeholder="Select Agent"
                          name="agentName"
                          // required={terminalType !== 4}
                          optionsType={allAgetns}
                          getOptionLabel={(option) => option.name}
                          value={
                            allAgetns.find((nom: any) => nom.id === formik.values.agentNameId) ||
                            null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("agentNameId", option?.id || "");
                            formik.setFieldValue("challanNumber", option?.challanNumber || "");
                          }}
                          error={formik.touched.agentNameId && Boolean(formik.errors.agentNameId)}
                          helperText={formik.touched.agentNameId && formik.errors.agentNameId}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Challan Number"
                          name="challanNumber"
                          placeholder="Challan Number"
                          disabled={true}
                          value={formik.values.challanNumber}
                          error={
                            formik.touched.challanNumber && Boolean(formik.errors.challanNumber)
                          }
                          helperText={formik.touched.challanNumber && formik.errors.challanNumber}
                        />
                      </Box>
                    </Grid>
                  </>
                )}

                <Grid xs={12} md={6}>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Boolean(atCommercialStation)}
                          onChange={(event) => {
                            setatCommercialStation(event.target.checked);
                          }}
                          name="atCommercialStation"
                          color="primary"
                        />
                      }
                      label="Vehicle at Commercial Station"
                    />
                  </Box>
                </Grid>
                {terminalType !== 4 && (
                  <Grid item xs={12} md={6} spacing={2}>
                    <Box
                      display="flex"
                      justifyContent="space-between" // spreads buttons evenly across available width
                      alignItems="center"
                      flexWrap="wrap"
                      style={{ gap: 1.5, marginTop: 1 }}
                    >
                      {!isExportMode && (
                        <CommonButton
                          disable={
                            formik.values.virNumber === "" ||
                            formik.values.indexNumber === "" ||
                            formik.values.PartyId === "" ||
                            formik.values.nominationName === ""
                          }
                          cssClass="customSubmitBtn"
                          onClick={() => {
                            calculateTariffPayment(formik.values, formik);
                          }}
                        >
                          Tarrif Payment
                        </CommonButton>
                      )}

                      <CommonButton
                        disable={
                          isExportMode
                            ? formik.values.vehicleNumber === ""
                            : formik.values.virNumber === "" || formik.values.indexNumber === ""
                        }
                        cssClass="customSubmitBtn"
                        onClick={() => {
                          calculateStoragePayment(formik.values, formik);
                        }}
                      >
                        Storage Charges
                      </CommonButton>
                      {!isExportMode && (
                        <CommonButton
                          disable={
                            containerDetails?.cargoType !== "DG" ||
                            (isExportMode
                              ? formik.values.gdNumber == "" || formik.values.vehicleNumber == ""
                              : formik.values.virNumber == "" || formik.values.indexNumber == "")
                          }
                          cssClass="customSubmitBtn"
                          onClick={() => {
                            calculateDGCargoPayment(formik.values, formik);
                          }}
                        >
                          DG Cargo Charges
                        </CommonButton>
                      )}
                      {/* Examination Charges - Export only */}
                      {isExportMode && (
                        <CommonButton
                          disable={formik.values.vehicleNumber === ""}
                          cssClass="customSubmitBtn"
                          onClick={() => {
                            calculateExaminationCharges(formik.values, formik);
                          }}
                        >
                          Examination Charges
                        </CommonButton>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12} md={6}>
                  <Box>
                    <CommonAutoCompleteField
                      cssClassName="customTextField"
                      error={formik.touched.paymentType && Boolean(formik.errors.paymentType)}
                      helperText={formik.touched.paymentType && formik.errors.paymentType}
                      label="Type of Payment"
                      placeholder="Type of Payment"
                      name="paymentType"
                      optionsType={paymentTypesList}
                      getOptionLabel={(option) => option.name}
                      groupBy={(option) => option.isFixed}
                      renderGroup={(params) => (
                        <li key={params.key}>
                          <GroupHeader>
                            {Number(params.group) == 0 ? "Variable Charges" : "Fixed Charges"}
                          </GroupHeader>
                          <GroupItems>{params.children}</GroupItems>
                        </li>
                      )}
                      required
                      value={
                        paymentTypesList.find((st: any) => st.name === formik.values.paymentType) ||
                        null
                      }
                      onChange={(option: any) => {
                        if (option && option.id !== 0) {
                          formik.setFieldValue("paymentTypeId", option.id);
                          formik.setFieldValue("paymentType", option.name);
                          formik.setFieldValue("isFixed", option.isFixed);
                          handleChange({ target: { value: option.name } });
                          if (option.name === "Other") {
                            setIsOtherPayment(true);
                          } else {
                            dispatch(getPaymentTypeDetailsAction(option.id));
                            setIsOtherPayment(false);
                          }
                        } else {
                          handleChange({ target: { value: null } });
                        }
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} className={!isOtherPayment ? classes.hideDatesGrid : ""}>
                  <TextField
                    className="customTextField"
                    required
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Other Payment"
                    name="otherPaymentName"
                    placeholder="Other Payment"
                    disabled={false}
                    value={formik.values.otherPaymentName}
                    onChange={handleChange}
                    error={
                      formik.touched.otherPaymentName && Boolean(formik.errors.otherPaymentName)
                    }
                    helperText={formik.touched.otherPaymentName && formik.errors.otherPaymentName}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextField
                      className="customTextField"
                      required
                      type="number"
                      InputProps={{ inputProps: { min: 0 } }}
                      size="small"
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Quantity"
                      name="paymentQuantity"
                      placeholder="Quantity"
                      disabled={
                        paymentTypeDetail.name === "Tarrif Payment" ||
                        paymentTypeDetail.name === "Port Demurrage Charges" ||
                        paymentTypeDetail.name === "Detention Charges"
                      }
                      onKeyDown={(evt) =>
                        (evt.key === "e" || evt.key === ".") && evt.preventDefault()
                      }
                      value={formik.values.paymentQuantity}
                      onChange={handleChange}
                      onPaste={(e: any) => {
                        if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                      }}
                      error={
                        formik.touched.paymentQuantity && Boolean(formik.errors.paymentQuantity)
                      }
                      helperText={formik.touched.paymentQuantity && formik.errors.paymentQuantity}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextField
                      className="customTextField"
                      required
                      type="number"
                      InputProps={{ inputProps: { min: 0 } }}
                      size="small"
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onKeyDown={(evt) =>
                        (evt.key === "e" || evt.key === ".") && evt.preventDefault()
                      }
                      label="Charges"
                      name="charges"
                      placeholder="Charges"
                      // placeholder="Charges Per Quantity"
                      disabled={
                        paymentTypeDetail.name === "Tarrif Payment" ||
                        paymentTypeDetail.name === "Port Demurrage Charges" ||
                        paymentTypeDetail.name === "Detention Charges" ||
                        (terminalType === 4 && discountApplied && discountPercentage > 0)
                      }
                      value={
                        terminalType === 4 &&
                        discountApplied &&
                        discountPercentage > 0 &&
                        originalCharges > 0
                          ? Math.round(
                              originalCharges - (originalCharges * discountPercentage) / 100
                            )
                          : originalCharges > 0
                          ? originalCharges
                          : formik.values.charges
                      }
                      onChange={(e) => {
                        const value = Number(e.target.value) || 0;
                        // If discount is applied, we need to calculate backwards to get original charges
                        if (terminalType === 4 && discountApplied && discountPercentage > 0) {
                          // Calculate original from discounted amount: discounted = original * (1 - percentage/100)
                          // So: original = discounted / (1 - percentage/100)
                          const calculatedOriginal = value / (1 - discountPercentage / 100);
                          setOriginalCharges(calculatedOriginal);
                          formik.setFieldValue("charges", value);
                        } else {
                          setOriginalCharges(value);
                          handleChange(e);
                        }
                      }}
                      onPaste={(e: any) => {
                        if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                      }}
                      error={formik.touched.charges && Boolean(formik.errors.charges)}
                      helperText={formik.touched.charges && formik.errors.charges}
                    />
                  </Box>
                </Grid>
                {terminalType === 4 && formik.values.paymentType && (
                  <>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={discountApplied}
                              onChange={(event) => {
                                setDiscountApplied(event.target.checked);
                                if (!event.target.checked) {
                                  setDiscountPercentage(0);
                                  // Restore original charges when discount is unchecked
                                  if (originalCharges > 0) {
                                    formik.setFieldValue("charges", originalCharges);
                                  }
                                } else {
                                  // Apply discount when checked
                                  if (originalCharges > 0 && discountPercentage > 0) {
                                    const discountedCharges = Math.round(
                                      originalCharges - (originalCharges * discountPercentage) / 100
                                    );
                                    formik.setFieldValue("charges", discountedCharges);
                                  }
                                }
                              }}
                              name="discountApplied"
                              color="primary"
                            />
                          }
                          label="Discount Applied"
                        />
                      </Box>
                    </Grid>
                    {discountApplied && (
                      <Grid item xs={12} md={6}>
                        <Box>
                          <TextField
                            className="customTextField"
                            type="number"
                            InputProps={{ inputProps: { min: 0, max: 100 } }}
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onKeyDown={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "." ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            label="Discount Percentage"
                            name="discountPercentage"
                            placeholder="Enter Discount Percentage"
                            disabled={false}
                            value={discountPercentage}
                            onChange={(e) => {
                              const value = Number(e.target.value) || 0;
                              const percentage = value > 100 ? 100 : value;
                              setDiscountPercentage(percentage);
                              // Update charges field when discount percentage changes
                              if (originalCharges > 0) {
                                const discountedCharges = Math.round(
                                  originalCharges - (originalCharges * percentage) / 100
                                );
                                formik.setFieldValue("charges", discountedCharges);
                              }
                            }}
                            onPaste={(e: any) => {
                              if (/[^0-9]/.test(e.clipboardData.getData("text")))
                                e.preventDefault();
                            }}
                            error={discountPercentage > 100}
                            helperText={
                              discountPercentage > 100 ? "Percentage cannot exceed 100" : ""
                            }
                          />
                        </Box>
                      </Grid>
                    )}
                    {discountApplied && discountPercentage > 0 && originalCharges > 0 && (
                      <Grid item xs={12} md={6}>
                        <Box>
                          <TextField
                            className="customTextField"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Total Charges"
                            name="discountedCharges"
                            placeholder="Total Charges"
                            disabled={true}
                            value={originalCharges > 0 ? Math.round(originalCharges) : 0}
                            error={false}
                            helperText="Amount without discount"
                          />
                        </Box>
                      </Grid>
                    )}
                  </>
                )}
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextField
                      className="customTextField"
                      size="small"
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Currency"
                      name="currency"
                      disabled={true}
                      value={formik.values.currency}
                      onChange={handleChange}
                      error={formik.touched.currency && Boolean(formik.errors.currency)}
                      helperText={formik.touched.currency && formik.errors.currency}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={!isOtherPayment ? 12 : 6}
                  md={!isOtherPayment ? 6 : 12}
                  lg={!isOtherPayment ? 12 : 6}
                  direction="row"
                >
                  <Box
                    textAlign="inherit"
                    mt={1}
                    mb={1}
                    className="terminalChargesSearchBtns headerButtonsConfig"
                    style={{ float: "right" }}
                  >
                    <CommonButton
                      cssClass="customSubmitBtn"
                      onClick={() => {
                        resetFilterForm();
                      }}
                    >
                      Reset
                    </CommonButton>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      isGreen
                      onClick={() => formik.submitForm()}
                    >
                      Add
                    </CommonButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <TerminalDetails
                details={containerDetails}
                nomination={nominationDetails}
                vehicleStatus={vehicleStatusData}
                isExportMode={isExportMode}
              />
            </Grid>
          </Grid>

          <div className={classes.grid}>
            <CommonMaterialGrid
              rows={filterGridRecord}
              columns={displayColumns}
              defaultPerPageRecord={50}
              height={450}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`Commercial_Terminal_charges_${Date.now()}`}
            />
          </div>
          <Grid spacing={2} container direction="row">
            <Grid item xs={4} md={4} className={classes.remarksDiv}>
              <Box>
                <TextField
                  className="customTextField"
                  size="small"
                  fullWidth
                  multiline
                  rows={1}
                  rowsMax={5}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Remarks"
                  name="remarks"
                  placeholder="Remarks"
                  disabled={false}
                  value={formik.values.remarks}
                  onChange={handleChange}
                  error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                  helperText={formik.touched.remarks && formik.errors.remarks}
                />
              </Box>
            </Grid>
            <Grid item xs={4} md={4} className={classes.remarksDiv}>
              <Box>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label="Tax Type (%)"
                  placeholder="Select Tax Type"
                  name="taxTypeId"
                  optionsType={allTaxTypeRows}
                  getOptionLabel={(option) =>
                    `${option.taxType.toString()} - ${option?.taxRate.toString()}%`
                  }
                  onChange={(row: any) => {
                    formik.setFieldValue("taxTypeId", row?.id);
                    formik.setFieldValue("tax", row);
                  }}
                  value={allTaxTypeRows.find((st: any) => st.id == formik.values.taxTypeId) || null}
                  error={formik.touched.taxTypeId && Boolean(formik.errors.taxTypeId)}
                  helperText={formik.touched.taxTypeId && formik.errors.taxTypeId}
                />
              </Box>
            </Grid>
            <Grid item xs={4} md={4} className={classes.remarksDiv}>
              <Box>
                <TextField
                  className="customTextField"
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: Number(totalAmount) } }}
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  label="Discount"
                  name="discount"
                  placeholder="Enter Discount"
                  disabled={false}
                  value={formik.values.discount}
                  onChange={handleChange}
                  onPaste={(e: any) => {
                    if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                  }}
                  error={formik.touched.discount && Boolean(formik.errors.discount)}
                  helperText={formik.touched.discount && formik.errors.discount}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            md={12}
            container
            className={`${classes.totalDiv} ${"commercialChargeTotalDiv"}`}
          >
            <Grid item md={3}>
              <Typography variant="h6" className={classes.subHeadings}>
                Total <span style={{ fontSize: "10px" }}>({formik.values.currency})</span>:{"  "}
                <span className={classes.totalVal}>{`${numberFormatting(
                  Number(totalAmount)
                )} `}</span>
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography variant="h6" className={classes.subHeadings}>
                STax Amount <span style={{ fontSize: "10px" }}>({formik.values.currency})</span>:
                {"  "}
                <span className={classes.totalVal}>{` ${numberFormatting(calculateTax())} `}</span>
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography variant="h6" className={classes.subHeadings}>
                Discount <span style={{ fontSize: "10px" }}>({formik.values.currency})</span>:{"  "}
                <span className={classes.totalVal}>{` ${numberFormatting(
                  Number(formik.values.discount) || 0
                )} `}</span>
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography variant="h6" className={classes.subHeadings}>
                Net Amount <span style={{ fontSize: "10px" }}>({formik.values.currency})</span>:
                {"  "}
                <span className={classes.totalVal}>
                  {" "}
                  {` ${numberFormatting(calculateNetAmount())} `}
                </span>
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpen}
        handleClose={handleCloseDialog}
        heading={"Are you sure you want to save the following charges?"}
        handleConfirm={handleConfirmDialog}
      >
        {dialogContent &&
          dialogContent?.split("#").map((data: any, index: any) => (
            <Box key={index}>
              <p style={{ lineHeight: "0.7" }}>{data}</p>
            </Box>
          ))}
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenDublicateDailog}
        handleClose={handleCloseDublicateDialog}
        heading={"Confirmation"}
        handleConfirm={handleSaveDublicateDialog}
      >
        Record against vehicle already present in same trip, do you want to save another one?
      </TransitionDialog>
    </div>
  );
}
